import React, { PureComponent, createElement, Fragment } from 'react';
import { message, Dropdown, Menu, Button, Icon, Modal, Form, Input, Radio } from 'antd';
import { connect } from 'react-redux';
import builder, { ComponentsManager, actions, services } from '@comall-backend-builder/core';
import { Entity } from '@comall-backend-builder/core/lib/parser';
import { forIn, get, set } from 'lodash';

import { errorHandle } from '../../services';
import { UploadButton } from '../upload-button';
import { ProductInfoExportButton } from '../product-info-export-button';
import {
    ProductGoodsModifySavePayload,
    registerProductGoodsModifySaveHandler,
} from './modify-save-button';
import { FormComponentProps } from 'antd/es/form';
import lodash from 'lodash';
import './index.less';
const { TextArea } = Input;

const api = services.api;

const SHELF_PRECHECK_API = '/product/shelf/precheck';
const SHELF_EXECUTE_API = '/product/shelf/execute';
const DEFAULT_UNLIST_BAN_REMARK = '零库存人工上架，无货仍展示';

type ShelfDimension = 'SPU' | 'SKU';
type ShelfOperation = 'LIST' | 'UNLIST';

type SelectedRowInfo = {
    sku: string;
    spu: string;
    name?: string;
    saleStatus?: string;
};

type ShelfPrecheckItem = {
    object_code?: string;
    sku_code?: string;
    spu_code?: string;
    object_name?: string;
    on_shelf?: boolean;
    list_ban_hit?: boolean;
    zero_stock_need_unlist_ban?: boolean;
    block_reason?: string | null;
};

export interface ProductGoodsViewProps {
    click: () => void;
    form: FormComponentProps['form'];
    entity: Entity;
    params: any;
    componentId: string;
    selectedRowKeys: string[];
}

export interface IState {
    selectedKeys: any;
    selectedRowMap: Record<string, SelectedRowInfo>;
    visible: boolean;
    black_remark: string;
    visibleClear: boolean;
    clearType: boolean;
    productModal: {
        visible: boolean;
        type: string;
    };
    shelfModal: {
        visible: boolean;
        operation: ShelfOperation;
        dimension: ShelfDimension;
        remark: string;
        loading: boolean;
    };
    shelfConfirmModal: {
        visible: boolean;
        loading: boolean;
        dimension: ShelfDimension;
        objectCodes: string[];
        cleanSkus: string[];
        listBanSkus: string[];
        zeroStockSkus: string[];
    };
    /** 行内保存：下架改上架时暂存，待预检/执行成功后再调原保存接口 */
    pendingRowSave: ProductGoodsModifySavePayload | null;
}

// 商品经营管理
class productGoodsView extends PureComponent<ProductGoodsViewProps, IState> {
    private tableColumns: any[] = [];

    constructor(props: any) {
        super(props);
        this.state = {
            selectedKeys: [],
            selectedRowMap: {},
            visible: false,
            black_remark: '',
            visibleClear: false,
            clearType: true,
            productModal: { visible: false, type: 'HIDE' },
            shelfModal: {
                visible: false,
                operation: 'LIST',
                dimension: 'SPU',
                remark: '',
                loading: false,
            },
            shelfConfirmModal: {
                visible: false,
                loading: false,
                dimension: 'SPU',
                objectCodes: [],
                cleanSkus: [],
                listBanSkus: [],
                zeroStockSkus: [],
            },
            pendingRowSave: null,
        };
        this.onAdd = this.onAdd.bind(this);
        this.putShelf = this.putShelf.bind(this);
        this.offShelf = this.offShelf.bind(this);
        this.onDeleteBatch = this.onDeleteBatch.bind(this);
        // this.uploadBlacklist = this.uploadBlacklist.bind(this);
        this.onDeleteAll = this.onDeleteAll.bind(this);
        this.handleOk = this.handleOk.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
    }

    componentDidMount() {
        registerProductGoodsModifySaveHandler(this.handleModifySave);
    }

    componentWillUnmount() {
        registerProductGoodsModifySaveHandler(null);
    }

    refreshGoodsList = () => {
        const { entity } = this.props;
        entity.search({
            ...entity.params,
            ...entity.filters,
        });
    };

    getSelectedRowInfo = (id: string | number): SelectedRowInfo | null => {
        const key = String(id);
        const cached = this.state.selectedRowMap[key];
        if (cached) {
            return cached;
        }
        const rows = (this.props.entity.result || []) as any[];
        const row = rows.find((item) => String(item.id) === key);
        if (!row) {
            return null;
        }
        return {
            sku: row.sku,
            spu: row.spu,
            name: row.name,
            saleStatus: row.saleStatus,
        };
    };

    getObjectCodes = (dimension: ShelfDimension): string[] => {
        const { pendingRowSave, selectedKeys } = this.state;
        if (pendingRowSave?.row) {
            const row = pendingRowSave.row;
            const code = dimension === 'SPU' ? row.spu : row.sku;
            return code ? [String(code)] : [];
        }
        const codes = (selectedKeys || [])
            .map((id: string | number) => {
                const info = this.getSelectedRowInfo(id);
                if (!info) {
                    return '';
                }
                return dimension === 'SPU' ? info.spu : info.sku;
            })
            .filter(Boolean);
        return Array.from(new Set(codes));
    };

    getNotOnShelfSkus = (): string[] => {
        const { selectedKeys } = this.state;
        return (selectedKeys || [])
            .map((id: string | number) => {
                const info = this.getSelectedRowInfo(id);
                if (!info) {
                    return String(id);
                }
                if (info.saleStatus === 'SALES') {
                    return '';
                }
                return info.sku || String(id);
            })
            .filter(Boolean);
    };

    getOnShelfSkus = (): string[] => {
        const { selectedKeys } = this.state;
        return (selectedKeys || [])
            .map((id: string | number) => {
                const info = this.getSelectedRowInfo(id);
                if (!info) {
                    return String(id);
                }
                if (info.saleStatus === 'SALES') {
                    return info.sku || String(id);
                }
                return '';
            })
            .filter(Boolean);
    };

    openShelfModal = (operation: ShelfOperation) => {
        const { selectedKeys } = this.state;
        if (!selectedKeys || selectedKeys.length === 0) {
            message.warning('请至少选择一项');
            return;
        }
        if (operation === 'LIST') {
            const onShelfSkus = this.getOnShelfSkus();
            if (onShelfSkus.length > 0) {
                message.warning('只有下架商品才能操作上架');
                return;
            }
        }
        if (operation === 'UNLIST') {
            const notOnShelfSkus = this.getNotOnShelfSkus();
            if (notOnShelfSkus.length > 0) {
                message.warning('只有上架商品才能操作下架');
                return;
            }
        }
        this.setState({
            pendingRowSave: null,
            shelfModal: {
                visible: true,
                operation,
                dimension: 'SPU',
                remark: '',
                loading: false,
            },
        });
    };

    clearPendingRowSave = () => {
        if (this.state.pendingRowSave) {
            this.setState({ pendingRowSave: null });
        }
    };

    /**
     * 行内保存：与 DataTable 默认 modifyConfirm 一致
     */
    doEntityModify = (row: any) => {
        const { entity, params, componentId } = this.props;
        const tableComponentId = componentId + '-Table';
        const columns = this.tableColumns || [];
        const fields: Record<string, any> = {};
        forIn(columns, (column: any) => {
            if (column.modifiable !== false && column.property) {
                set(fields, column.property, get(row, column.property));
            }
        });
        const requestParams = { ...(params || {}), id: row.id };
        const store = builder.getStore();
        store.dispatch(actions.componentSubmitAction(tableComponentId, 'modify'));
        entity.modify(fields, requestParams, {
            action: actions.tableModifyFinishAction(tableComponentId, entity),
        });
    };

    /**
     * 行内「保存」：仅下架→上架时先走预检/执行，再调原保存；其余保持原逻辑
     */
    handleModifySave = ({ row }: ProductGoodsModifySavePayload) => {
        const { entity } = this.props;
        const original = ((entity.result || []) as any[]).find(
            (item) => String(item.id) === String(row.id)
        );
        const originalStatus = original?.saleStatus;
        const nextStatus = row?.saleStatus;
        const isOffToOn = originalStatus === 'NOT_SALES' && nextStatus === 'SALES';

        if (!isOffToOn) {
            this.doEntityModify(row);
            return;
        }

        this.setState({
            pendingRowSave: { row },
            shelfModal: {
                visible: true,
                operation: 'LIST',
                dimension: 'SPU',
                remark: '',
                loading: false,
            },
        });
    };

    closeShelfModal = () => {
        this.setState((prev) => ({
            shelfModal: {
                ...prev.shelfModal,
                visible: false,
                loading: false,
            },
        }));
    };

    handleShelfModalCancel = () => {
        this.closeShelfModal();
        this.clearPendingRowSave();
    };

    closeShelfConfirmModal = () => {
        this.setState((prev) => ({
            shelfConfirmModal: {
                ...prev.shelfConfirmModal,
                visible: false,
                loading: false,
            },
        }));
    };

    handleShelfConfirmCancel = () => {
        this.closeShelfConfirmModal();
        this.clearPendingRowSave();
    };

    normalizePrecheckList = (res: any): ShelfPrecheckItem[] => {
        let rawList: any[] = [];
        if (Array.isArray(res)) {
            rawList = res;
        } else if (Array.isArray(res?.result)) {
            rawList = res.result;
        } else if (Array.isArray(res?.resultBody)) {
            rawList = res.resultBody;
        } else if (Array.isArray(res?.data)) {
            rawList = res.data;
        }

        // api 层会把响应字段转成 camelCase，这里统一成业务字段
        return rawList.map((item) => ({
            object_code: item.object_code || item.objectCode,
            sku_code: item.sku_code || item.skuCode,
            spu_code: item.spu_code || item.spuCode,
            object_name: item.object_name || item.objectName,
            on_shelf: item.on_shelf ?? item.onShelf,
            list_ban_hit: item.list_ban_hit ?? item.listBanHit,
            zero_stock_need_unlist_ban:
                item.zero_stock_need_unlist_ban ?? item.zeroStockNeedUnlistBan,
            block_reason: item.block_reason ?? item.blockReason ?? null,
        }));
    };

    showBlockedTip = (items: ShelfPrecheckItem[]) => {
        Modal.warning({
            title: '不可上架',
            content: (
                <div className="shelf-batch-tip">
                    {items.map((item, index) => (
                        <div key={`${item.sku_code || item.object_code || index}`}>
                            {[item.sku_code ? `${item.sku_code}:` : '', item.block_reason]
                                .filter(Boolean)
                                .join(' ')}
                        </div>
                    ))}
                </div>
            ),
            onOk: () => {
                this.refreshGoodsList();
            },
        });
    };

    showOnShelfTip = (items: ShelfPrecheckItem[]) => {
        Modal.info({
            title: '提示',
            content: (
                <div className="shelf-batch-tip">
                    <div>以下 {items.length} 个商品不可上架</div>
                    {items.map((item, index) => (
                        <div key={`${item.sku_code || item.object_code || index}`}>
                            {item.sku_code || item.object_code} 已在上架
                        </div>
                    ))}
                </div>
            ),
            onOk: () => {
                this.refreshGoodsList();
            },
        });
    };

    tipExecuteMessages = (messages: string[] = []) => {
        const content = (Array.isArray(messages) ? messages : []).filter(Boolean);
        if (content.length === 0) {
            message.warning('操作未完全成功');
            return;
        }
        if (content.length === 1) {
            message.warning(content[0]);
            return;
        }
        Modal.warning({
            title: '提示',
            content: (
                <div className="shelf-batch-tip">
                    {content.map((msg, index) => (
                        <div key={index}>{msg}</div>
                    ))}
                </div>
            ),
        });
    };

    tipExecuteResult = (res?: any) => {
        const banSkipped = res?.banSkippedSkuCodes ?? res?.ban_skipped_sku_codes;
        const failCount = res?.failCount ?? res?.fail_count;
        const hasBanSkipped = Array.isArray(banSkipped) && banSkipped.length > 0;
        if (hasBanSkipped || Number(failCount) > 0) {
            this.tipExecuteMessages(res?.messages);
            return;
        }
        // 成功时 messages 可能很长，只提示操作成功
        message.success('操作成功');
    };

    handleExecuteResult = (res?: any) => {
        this.tipExecuteResult(res);
        this.refreshGoodsList();
    };

    executeShelf = (params: Record<string, any>) => {
        const pendingRowSave = this.state.pendingRowSave;
        return api
            .post(params, { apiPath: SHELF_EXECUTE_API })
            .then((res: any) => {
                this.closeShelfModal();
                this.closeShelfConfirmModal();
                if (pendingRowSave?.row) {
                    this.setState({ pendingRowSave: null });
                    // 上架预检/执行成功后，再走原有行内保存
                    this.doEntityModify(pendingRowSave.row);
                    this.tipExecuteResult(res);
                } else {
                    this.handleExecuteResult(res);
                }
            })
            .catch((error: any) => {
                this.setState((prev) => ({
                    shelfModal: { ...prev.shelfModal, loading: false },
                    shelfConfirmModal: { ...prev.shelfConfirmModal, loading: false },
                }));
                errorHandle(error);
            });
    };

    handlePrecheckResult = (
        list: ShelfPrecheckItem[],
        dimension: ShelfDimension,
        objectCodes: string[]
    ) => {
        const blocked = list.filter((item) => item.block_reason);
        const onShelfItems = list.filter((item) => item.on_shelf);
        const listBanItems = list.filter((item) => item.list_ban_hit);
        const zeroStockItems = list.filter((item) => item.zero_stock_need_unlist_ban);
        const cleanItems = list.filter(
            (item) =>
                !item.block_reason &&
                !item.on_shelf &&
                !item.list_ban_hit &&
                !item.zero_stock_need_unlist_ban
        );

        // 情况 1 / 2：仅提示，整批不执行
        if (blocked.length > 0) {
            this.closeShelfModal();
            this.clearPendingRowSave();
            this.showBlockedTip(blocked);
            return;
        }
        if (onShelfItems.length > 0) {
            this.closeShelfModal();
            this.clearPendingRowSave();
            this.showOnShelfTip(onShelfItems);
            return;
        }

        // 情况 3：全部可直接执行
        if (listBanItems.length === 0 && zeroStockItems.length === 0) {
            this.setState((prev) => ({
                shelfModal: { ...prev.shelfModal, loading: true },
            }));
            this.executeShelf({
                dimension,
                object_codes: objectCodes,
                operation: 'LIST',
            });
            return;
        }

        // 情况 3 / 4 / 5：确认后执行
        this.setState({
            shelfModal: {
                ...this.state.shelfModal,
                visible: false,
                loading: false,
            },
            shelfConfirmModal: {
                visible: true,
                loading: false,
                dimension,
                objectCodes,
                cleanSkus: cleanItems
                    .map((item) => item.sku_code || item.object_code || '')
                    .filter(Boolean),
                listBanSkus: listBanItems
                    .map((item) => item.sku_code || item.object_code || '')
                    .filter(Boolean),
                zeroStockSkus: zeroStockItems
                    .map((item) => item.sku_code || item.object_code || '')
                    .filter(Boolean),
            },
        });
    };

    handleShelfModalOk = () => {
        const { shelfModal } = this.state;
        const { operation, dimension, remark } = shelfModal;
        const objectCodes = this.getObjectCodes(dimension);
        if (objectCodes.length === 0) {
            message.warning('未获取到有效的商品编码，请重新勾选');
            return;
        }

        if (operation === 'UNLIST') {
            const trimRemark = (remark || '').trim();
            if (!trimRemark) {
                message.warning('请填写说明');
                return;
            }
            this.setState((prev) => ({
                shelfModal: { ...prev.shelfModal, loading: true },
            }));
            this.executeShelf({
                dimension,
                object_codes: objectCodes,
                operation: 'UNLIST',
                remark: trimRemark,
            });
            return;
        }

        this.setState((prev) => ({
            shelfModal: { ...prev.shelfModal, loading: true },
        }));
        api.post(
            {
                dimension,
                object_codes: objectCodes,
                operation: 'LIST',
            },
            { apiPath: SHELF_PRECHECK_API }
        )
            .then((res: any) => {
                const list = this.normalizePrecheckList(res);
                this.setState((prev) => ({
                    shelfModal: { ...prev.shelfModal, loading: false },
                }));
                this.handlePrecheckResult(list, dimension, objectCodes);
            })
            .catch((error: any) => {
                this.setState((prev) => ({
                    shelfModal: { ...prev.shelfModal, loading: false },
                }));
                errorHandle(error);
            });
    };

    handleShelfConfirmOk = () => {
        const { shelfConfirmModal } = this.state;
        const { dimension, objectCodes, listBanSkus, zeroStockSkus } = shelfConfirmModal;
        const params: Record<string, any> = {
            dimension,
            object_codes: objectCodes,
            operation: 'LIST',
        };
        if (listBanSkus.length > 0) {
            params.confirm_clear_list_ban = true;
        }
        if (zeroStockSkus.length > 0) {
            params.confirm_add_unlist_ban = true;
            params.unlist_ban_remark = DEFAULT_UNLIST_BAN_REMARK;
        }
        this.setState((prev) => ({
            shelfConfirmModal: { ...prev.shelfConfirmModal, loading: true },
        }));
        this.executeShelf(params);
    };
    handleOk = (e?: any) => {
        e.preventDefault();
        this.props.form.validateFields((err, values) => {
            if (!err) {
                if (this.state.visible) {
                    const { entity } = this.props;
                    const { selectedKeys } = this.state;
                    let copyselect = selectedKeys.join(',');
                    api.get(
                        {
                            sku_ids: copyselect,
                            black_remark: values.black_remark,
                            is_style: values.is_style,
                        },
                        {
                            apiPath: `/products/add_black`,
                        }
                    )
                        .then((res: any) => {
                            res.data
                                ? message.success('加入黑名单成功')
                                : message.info('已在黑名单中');
                            entity.search({
                                ...entity.params,
                                ...entity.filters,
                            });
                        })
                        .catch(errorHandle);
                } else {
                }
                this.setState({
                    visible: false,
                });
                // 列表数据刷新
                this.props.entity.search({
                    ...this.props.entity.params,
                    ...this.props.entity.filters,
                });
            } else {
                message.error('请填写完整表单再提交');
            }
        });
    };

    handleCancel = () => {
        this.props.form.resetFields();
        this.setState({ visible: false });
    };

    onAdd() {
        this.props.form.resetFields();
        const { selectedKeys } = this.state;
        if (selectedKeys.length === 0) {
            message.warning('请至少选择一项');
        } else {
            this.setState({ visible: true });
            if (this.state.visible) {
                this.handleOk();
            }
        }
    }

    onFinishFailed = (errorInfo: any) => {
        console.log('Failed:', errorInfo);
    };
    // 批量上架
    putShelf() {
        this.openShelfModal('LIST');
    }

    // 批量下架
    offShelf() {
        this.openShelfModal('UNLIST');
    }

    onDeleteBatch() {
        const { entity } = this.props;
        const { selectedKeys, clearType } = this.state;
        if (selectedKeys.length === 0) {
            message.warning('请至少选择一项');
            this.setState({ visibleClear: false });
        } else {
            let copyselect = selectedKeys.join(',');
            api.get({ is_style: clearType }, { apiPath: `/products/remove_black/${copyselect}` })
                .then(() => {
                    message.success('移出黑名单成功');
                    entity.search({
                        ...entity.params,
                        ...entity.filters,
                    });
                })
                .catch(errorHandle)
                .finally(() => {
                    this.setState({
                        visibleClear: false,
                    });
                });
        }
    }

    onDeleteAll() {
        const {
            entity: {
                filters,
                paging: { page, perPage },
            },
        } = this.props;

        const params = {
            page,
            perPage,
            ...filters,
        };
        api.get(params, { apiPath: `/products/skuBlackList/export` })
            .then(() => {
                message.success('导出成功，请到 报表管理 - 报表导出管理 中查看');
            })
            .catch(errorHandle);
    }

    onChangeType = (e) => {
        this.setState({ clearType: e?.target?.value });
    };

    renderTable() {
        const { entity, componentId } = this.props;
        const tableProps = {
            entity,
            componentId: componentId + '-Table',
            component: 'DataTable',
            switchRefresh: true,
            loadFirstPage: true,
            rowSelection: {
                onChange: (selectedKeys: string[], selectedRows: any[] = []) => {
                    this.setState((prev) => {
                        const nextMap: Record<string, SelectedRowInfo> = {
                            ...prev.selectedRowMap,
                        };
                        (selectedRows || []).forEach((row) => {
                            if (!row || row.id == null) {
                                return;
                            }
                            nextMap[String(row.id)] = {
                                sku: row.sku,
                                spu: row.spu,
                                name: row.name,
                                saleStatus: row.saleStatus,
                            };
                        });
                        Object.keys(nextMap).forEach((key) => {
                            if (!selectedKeys.map(String).includes(key)) {
                                delete nextMap[key];
                            }
                        });
                        return {
                            selectedKeys,
                            selectedRowMap: nextMap,
                        };
                    });
                },
            },
            // dataSource: entity.result,
            pagination: {
                pageSize: 10,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['10', '15', '20'],
                showTotal(total: number) {
                    return `共 ${total} 条记录`;
                },
            },
            scroll: { x: true },
            columns: [
                {
                    property: 'id',
                    modifiable: false,
                    fixed: 'left',
                },
                {
                    property: 'sku',
                    modifiable: false,
                    width: 170,
                    fixed: 'left',
                },
                {
                    property: 'spu',
                    modifiable: false,
                    width: 170,
                },
                {
                    property: 'pzgPic',
                    width: 100,
                    modifiable: false,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'middlePic',
                    width: 100,
                    modifiable: false,
                    displayConfig: {
                        style: {
                            width: 50,
                            height: 50,
                        },
                        preview: {
                            visible: true,
                            size: 400,
                            placement: 'right',
                        },
                    },
                },
                {
                    property: 'name',
                    modifiable: false,
                    width: 220,
                },
                {
                    property: 'styleCode',
                    modifiable: false,
                    width: 120,
                },
                {
                    property: 'salesTags',
                    modifiable: false,
                    width: 120,
                },
                // {
                //     property: 'blackFlag',
                //     width: 120,
                //     modifiable: false,
                //     displayConfig: {
                //         statusConfig: {
                //             1: {
                //                 text: '是',
                //                 status: 'success',
                //             },
                //             0: {
                //                 text: '否',
                //                 status: 'error',
                //             },
                //         },
                //     },
                // },
                {
                    property: 'listBanHit',
                    width: 160,
                    modifiable: false,
                    displayConfig: {
                        statusConfig: {
                            HIT: {
                                text: '已命中',
                                status: 'error',
                            },
                            NOT_HIT: {
                                text: '未命中',
                                status: 'success',
                            },
                        },
                    },
                },
                {
                    property: 'unlistBanHit',
                    width: 160,
                    modifiable: false,
                    displayConfig: {
                        statusConfig: {
                            HIT: {
                                text: '已命中',
                                status: 'error',
                            },
                            NOT_HIT: {
                                text: '未命中',
                                status: 'success',
                            },
                        },
                    },
                },
                // {
                //     property: 'blackRemark',
                //     modifiable: false,
                //     width: 120,
                // },
                {
                    property: 'ecStock',
                    modifiable: false,
                },
                {
                    property: 'totalStock',
                    modifiable: false,
                },
                {
                    property: 'ecAvailableStock',
                    modifiable: false,
                },
                {
                    property: 'availableStock',
                    modifiable: false,
                },
                {
                    property: 'saleStatus',
                    width: 120,
                    displayConfig: {
                        statusConfig: {
                            SALES: {
                                text: '上架',
                                status: 'success',
                            },
                            NOT_SALES: {
                                text: '下架',
                                status: 'error',
                            },
                        },
                    },
                },
                {
                    property: 'supportAppointment',
                    width: 120,
                    displayConfig: {
                        statusConfig: {
                            SUPPORT: {
                                text: '支持',
                                status: 'success',
                            },
                            NOT_SUPPORT: {
                                text: '不支持',
                                status: 'error',
                            },
                        },
                    },
                },
                {
                    property: 'searchType',
                    width: 120,
                    displayConfig: {
                        statusConfig: {
                            '0': {
                                text: '可搜索',
                                status: 'success',
                            },
                            '1': {
                                text: '隐藏',
                                status: 'error',
                            },
                        },
                    },
                },
                {
                    property: 'isTopping',
                    width: 120,
                    displayConfig: {
                        statusConfig: {
                            SUPPORT: {
                                text: '是',
                                status: 'success',
                            },
                            NOT_SUPPORT: {
                                text: '否',
                                status: 'error',
                            },
                        },
                    },
                },
                {
                    property: 'supportPreSales',
                    width: 120,
                    modifiable: false,
                    displayConfig: {
                        statusConfig: {
                            SUPPORT: {
                                text: '支持',
                                status: 'success',
                            },
                            NOT_SUPPORT: {
                                text: '不支持',
                                status: 'error',
                            },
                        },
                    },
                },
                {
                    property: 'preStartTime',
                    modifiable: false,
                },
                {
                    property: 'preEndTime',
                    modifiable: false,
                },
                {
                    property: 'preHotStartTime',
                    modifiable: false,
                },
                {
                    property: 'preHotEndTime',
                    modifiable: false,
                },
                {
                    property: 'preSendDay',
                    modifiable: false,
                },
                // {
                //     property: 'supportCustomerMade',
                // },
                {
                    property: 'price',
                    modifiable: false,
                },
            ],
            actionColumn: {
                title: '操作',
                width: 200,
                fixed: 'right',
                style: {
                    height: '80px',
                },
                items: [
                    {
                        type: 'link',
                        text: '查看',
                        path: '/product/goods/{{row.id}}?skuCode={{row.sku}}',
                    },
                    {
                        type: 'component',
                        component: 'PreviewProductBtn',
                    },
                    {
                        type: 'component',
                        component: 'QrCodeBtn',
                    },
                    {
                        type: 'component',
                        component: 'QrSmartCodeBtn',
                    },
                    {
                        text: '编辑',
                        type: 'modify',
                        config: {
                            type: 'link',
                        },
                    },
                    {
                        type: 'component',
                        component: 'ProductGoodsModifySaveButton',
                    },
                    {
                        text: '取消',
                        type: 'modifyCancel',
                        config: {
                            type: 'link',
                        },
                    },
                ],
            },
        };
        this.tableColumns = tableProps.columns || [];
        return createElement(ComponentsManager.get('DataTable'), tableProps);
    }

    downloadMould(url: string) {
        services.api.download({}, { apiPath: url }).catch((e: any) => errorHandle(e));
    }

    /**
     * @param type 0:可搜索 1:隐藏 3:模板下载
     */
    handleSearchProduct = (type: string) => {
        const { selectedKeys } = this.state;
        if (type === '0' || type === '1') {
            if (selectedKeys.length === 0) return message.warning('请至少选择一项');

            this.setState({
                productModal: { visible: true, type: type === '1' ? 'HIDE' : 'SHOW' },
            });
        } else {
            this.downloadMould('/templates/UPDATE_PRODUCT_HIDDEN');
        }
    };

    /**
     * 设置商品是否可搜索
     * @param type 0:确定 1:取消
     */
    handleClickProductModal = (type: string) => {
        const { selectedKeys: sku_id_list, productModal: _productModal } = this.state;
        const productModal = { ..._productModal, visible: false };
        if (type === '0') {
            const search_type = _productModal.type === 'HIDE' ? 1 : 0;
            const { entity } = this.props;
            api.put(
                { search_type, sku_id_list },
                { apiPath: '/products/updateProductHidden' }
            ).then(
                () => {
                    message.success('设置成功');
                    entity.search({ ...entity.params, ...entity.filters });
                    this.setState({ productModal });
                },
                (e) => errorHandle(e)
            );
        } else {
            this.setState({ productModal });
        }
    };

    render() {
        const { getFieldDecorator } = this.props.form;
        const {
            selectedKeys,
            productModal,
            shelfModal,
            shelfConfirmModal,
            pendingRowSave,
        } = this.state;
        const selectedSkuCount = pendingRowSave
            ? this.getObjectCodes('SKU').length || 1
            : this.getObjectCodes('SKU').length || selectedKeys.length;
        // 批量上下架
        const upAndDownMenu = (
            <Menu>
                <Menu.Item key="1">
                    <Button
                        type="link"
                        onClick={() => {
                            this.putShelf();
                        }}
                    >
                        按勾选批量上架
                    </Button>
                </Menu.Item>
                <Menu.Item key="2">
                    <Button
                        type="link"
                        onClick={() => {
                            this.offShelf();
                        }}
                    >
                        按勾选批量下架
                    </Button>
                </Menu.Item>
                <Menu.Item key="3">
                    <Button
                        type="link"
                        onClick={() => {
                            services.navigation.goto('/product/shelfRule?tab=list');
                        }}
                    >
                        维护禁止上下架名单
                    </Button>
                </Menu.Item>
                <Menu.Item key="4">
                    <Button
                        type="link"
                        onClick={() => {
                            this.downloadMould('/templates/SHELF_MANUAL_SHELF');
                        }}
                    >
                        批量上下架模板
                    </Button>
                </Menu.Item>
                <Menu.Item key="5">
                    <UploadButton
                        accept=".xls,.xlsx,.csv"
                        action="/templates/SHELF_MANUAL_SHELF"
                        buttons={{ text: '批量修改上下架', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={130}
                    />
                </Menu.Item>
            </Menu>
        );

        // 预售
        const presaleMenu = (
            <Menu>
                <Menu.Item key="1">
                    <UploadButton
                        accept=".xls,.xlsx,.csv"
                        action="/templates/UPDATE_PRE_SALE_BULK"
                        buttons={{ text: '批量预售设置', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={116}
                    />
                </Menu.Item>
                <Menu.Item key="2">
                    <Button
                        type="link"
                        onClick={() => {
                            this.downloadMould('/templates/UPDATE_PRE_SALE_BULK');
                        }}
                    >
                        批量预售模版
                    </Button>
                </Menu.Item>
            </Menu>
        );

        // 黑名单
        const blacklistMenu = (
            <Menu>
                <Menu.Item key="1">
                    <Button
                        type="link"
                        onClick={() => {
                            this.onAdd();
                        }}
                    >
                        按勾选加入黑名单
                    </Button>
                </Menu.Item>
                <Menu.Item key="2">
                    <Button
                        type="link"
                        onClick={() => {
                            if (selectedKeys.length === 0) {
                                message.warning('请至少选择一项');
                                return;
                            }
                            this.setState({ clearType: true, visibleClear: true });
                        }}
                    >
                        按勾选移除黑名单
                    </Button>
                </Menu.Item>
                <Menu.Item key="3">
                    <Button
                        type="link"
                        onClick={() => {
                            this.downloadMould('/templates/IMPORT_SKU_BLACK_LIST_V2');
                        }}
                    >
                        黑名单模版下载
                    </Button>
                </Menu.Item>
                <Menu.Item key="4">
                    <UploadButton
                        accept=".xls,.xlsx,.csv"
                        action="/templates/ADD_BLACK_LIST_V2"
                        buttons={{ text: '批量上传黑名单', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={130}
                    />
                </Menu.Item>
            </Menu>
        );

        // 商品搜索设置
        const productSearchMenu = (
            <Menu>
                <Menu.Item key="1">
                    <Button type="link" onClick={() => this.handleSearchProduct('1')}>
                        按勾选设为隐藏
                    </Button>
                </Menu.Item>
                <Menu.Item key="0">
                    <Button type="link" onClick={() => this.handleSearchProduct('0')}>
                        按勾选设为可搜索
                    </Button>
                </Menu.Item>
                <Menu.Item key="3">
                    <Button type="link" onClick={() => this.handleSearchProduct('3')}>
                        批量设置-模板下载
                    </Button>
                </Menu.Item>
                <Menu.Item key="4">
                    <UploadButton
                        accept=".xls,.xlsx,.csv"
                        action="/templates/UPDATE_PRODUCT_HIDDEN"
                        buttons={{ text: '批量设置-上传', type: 'link' }}
                        failTitle={'导入失败了'}
                        maxSize={100 * 1024}
                        successTitle="导入成功，请稍后查看"
                        isDropdownWidth={130}
                    />
                </Menu.Item>
            </Menu>
        );

        return (
            <>
                <Fragment>
                    <div className="optionBox">
                        <Dropdown overlay={upAndDownMenu}>
                            <Button type="primary">
                                批量修改上下架 <Icon type="down" />
                            </Button>
                        </Dropdown>
                        {/* <Dropdown overlay={blacklistMenu}>
                            <Button type="primary">
                                批量操作黑名单 <Icon type="down" />
                            </Button>
                        </Dropdown> */}
                        <Dropdown overlay={presaleMenu}>
                            <Button type="primary">
                                批量预售设置 <Icon type="down" />
                            </Button>
                        </Dropdown>
                        <Dropdown overlay={productSearchMenu}>
                            <Button type="primary">
                                商品搜索设置 <Icon type="down" />
                            </Button>
                        </Dropdown>

                        <ProductInfoExportButton
                            text="商品资料导出"
                            source={{ apiPath: '/products/export' }}
                            entity={this.props.entity}
                        />
                    </div>
                    {this.renderTable()}
                </Fragment>
                <Modal
                    title="加入黑名单"
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    okText={'保存'}
                >
                    <Form layout="vertical">
                        <Form.Item label="加入方式">
                            {getFieldDecorator('is_style', {
                                rules: [{ required: true, message: '请选择加入方式' }],
                                initialValue: true,
                            })(
                                <Radio.Group>
                                    <Radio value={true}>按同款加入黑名单</Radio>
                                    <Radio value={false}>按所选sku加入黑名单</Radio>
                                </Radio.Group>
                            )}
                        </Form.Item>
                        <Form.Item label="黑名单备注">
                            {getFieldDecorator('black_remark', {
                                rules: [{ required: true, message: '请输入黑名单备注' }],
                            })(
                                <TextArea
                                    rows={4}
                                    maxLength={300}
                                    placeholder="最多输入300个字符！！"
                                />
                            )}
                        </Form.Item>
                    </Form>
                </Modal>

                <Modal
                    title="移出黑名单"
                    visible={this.state.visibleClear}
                    onOk={this.onDeleteBatch}
                    onCancel={() => this.setState({ visibleClear: false })}
                    okText={'确定'}
                >
                    <div className="clearBox">
                        <div className="clearBoxTitle">确认移出黑名单?</div>
                        <div className="clearValue">
                            已选{selectedKeys?.length}条数据，移出黑名单后，黑名单备注被清空
                        </div>
                        <div className="clearLabel">移出方式</div>
                        <Radio.Group onChange={this.onChangeType} value={this.state.clearType}>
                            <Radio value={true}>按同款移出黑名单</Radio>
                            <Radio value={false}>按所选sku移出黑名单</Radio>
                        </Radio.Group>
                    </div>
                </Modal>

                <Modal
                    title={`商品搜索设为${productModal.type === 'HIDE' ? '隐藏' : '可搜索'}`}
                    visible={productModal.visible}
                    onOk={() => this.handleClickProductModal('0')}
                    onCancel={() => this.handleClickProductModal('1')}
                >
                    <p>确认将商品搜索设为{productModal.type === 'HIDE' ? '隐藏' : '可搜索'}?</p>
                    <p>已选{selectedKeys.length || 0}条数据。</p>
                    <p>
                        商品将{productModal.type === 'HIDE' ? '不会' : '会'}
                        出现在品真阁小程序的搜索结果中。
                    </p>
                </Modal>

                <Modal
                    title={shelfModal.operation === 'LIST' ? '人工上架' : '人工下架'}
                    visible={shelfModal.visible}
                    onOk={this.handleShelfModalOk}
                    onCancel={this.handleShelfModalCancel}
                    confirmLoading={shelfModal.loading}
                    destroyOnClose
                    okText="确定"
                    cancelText="取消"
                >
                    <div className="shelf-batch-modal">
                        <div className="shelf-batch-modal__count">
                            已选商品 {selectedSkuCount} 个 SKU
                        </div>
                        <div className="shelf-batch-modal__row">
                            <div className="shelf-batch-modal__label">操作粒度</div>
                            <Radio.Group
                                value={shelfModal.dimension}
                                onChange={(e) => {
                                    const dimension = e.target.value;
                                    this.setState((prev) => ({
                                        shelfModal: {
                                            ...prev.shelfModal,
                                            dimension,
                                        },
                                    }));
                                }}
                            >
                                <Radio value="SPU">按 SPU</Radio>
                                <Radio value="SKU">按 SKU</Radio>
                            </Radio.Group>
                        </div>
                        {shelfModal.operation === 'UNLIST' && (
                            <>
                                <div className="shelf-batch-modal__label shelf-batch-modal__label--required">
                                    说明
                                </div>
                                <div className="shelf-batch-modal__remark">
                                    <TextArea
                                        rows={4}
                                        maxLength={200}
                                        value={shelfModal.remark}
                                        onChange={(e) => {
                                            const remark = e.target.value;
                                            this.setState((prev) => ({
                                                shelfModal: {
                                                    ...prev.shelfModal,
                                                    remark,
                                                },
                                            }));
                                        }}
                                    />
                                    <div className="shelf-batch-modal__remark-count">
                                        {(shelfModal.remark || '').length} / 200
                                    </div>
                                </div>
                            </>
                        )}
                        <div className="shelf-batch-modal__tip">
                            {shelfModal.operation === 'LIST'
                                ? '硬门禁：有图 + 非预售 + 品类适用。命中禁止上架名单须确认清除；零库存须确认加入禁止下架名单。'
                                : '下架后将写入禁止上架名单，禁止自动再上架。不允许只下架不入名单。'}
                        </div>
                    </div>
                </Modal>

                <Modal
                    title="批量上架确认"
                    visible={shelfConfirmModal.visible}
                    onOk={this.handleShelfConfirmOk}
                    onCancel={this.handleShelfConfirmCancel}
                    confirmLoading={shelfConfirmModal.loading}
                    destroyOnClose
                    width={640}
                    okText="确定"
                    cancelText="取消"
                >
                    <div className="shelf-batch-confirm">
                        {shelfConfirmModal.cleanSkus.length > 0 && (
                            <div className="shelf-batch-confirm__section">
                                <div>
                                    以下 {shelfConfirmModal.cleanSkus.length}{' '}
                                    个商品无需确认，将直接上架
                                </div>
                                {shelfConfirmModal.cleanSkus.map((sku) => (
                                    <div key={`clean-${sku}`}>{sku}</div>
                                ))}
                            </div>
                        )}
                        {shelfConfirmModal.listBanSkus.length > 0 && (
                            <div className="shelf-batch-confirm__section">
                                <div>
                                    以下 {shelfConfirmModal.listBanSkus.length}{' '}
                                    个商品在禁止上架名单中，（逐条确认）：
                                </div>
                                <div>
                                    确认后将先移出挡住本次上架的名单记录(当前 SKU，以及所属SPU
                                    如有)，再执行上架。取消则不上架、不改名单。
                                </div>
                                {shelfConfirmModal.listBanSkus.map((sku) => (
                                    <div key={`ban-${sku}`}>{sku}</div>
                                ))}
                            </div>
                        )}
                        {shelfConfirmModal.zeroStockSkus.length > 0 && (
                            <div className="shelf-batch-confirm__section">
                                <div>
                                    以下 {shelfConfirmModal.zeroStockSkus.length} 个商品可售库存为
                                    0(逐条确认)：
                                </div>
                                <div>
                                    当前可售库存为 0，确认上架将把该 SPU 加入禁止下架名单。按 SPU
                                    写入后，同 SPU 下其他 SKU
                                    也将按并集命中，仅豁免「零库存且有图」的 24
                                    小时倒计时与到期下架；已上架且当前体系无图时仍立即下架，并清除挡住本次目标的禁止下架名单记录。可改写说明；取消则不上架、不加白名单。
                                </div>
                                {shelfConfirmModal.zeroStockSkus.map((sku) => (
                                    <div key={`zero-${sku}`}>{sku}</div>
                                ))}
                            </div>
                        )}
                    </div>
                </Modal>
            </>
        );
    }
}

// export const ProductGoodsView = connect()(productGoodsView);
export const ProductGoodsView = Form.create()(productGoodsView);
